export const API_BASE_URL =
  "https://www.softwaresme.com/software/united_corp_admim/api/";
